module.exports = __webpack_public_path__ + "media/images/japan/nav_1-317987f7e57230fbb053d0e72e6b7cac.svg";